(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5105],{

/***/ 75105:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ FlightSearch_FlightSearch; }
});

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(67573);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(14251);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(52875);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(93946);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Close.js
var Close = __webpack_require__(50594);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/createTheme.js + 13 modules
var createTheme = __webpack_require__(68239);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/ThemeProvider.js + 5 modules
var ThemeProvider = __webpack_require__(22430);
// EXTERNAL MODULE: ./node_modules/@mui/material/Select/Select.js + 4 modules
var Select = __webpack_require__(18360);
// EXTERNAL MODULE: ./node_modules/@mui/material/MenuItem/MenuItem.js + 2 modules
var MenuItem = __webpack_require__(30431);
// EXTERNAL MODULE: ./node_modules/@mui/material/FormControl/FormControl.js + 1 modules
var FormControl = __webpack_require__(94054);
// EXTERNAL MODULE: ./node_modules/@mui/material/InputLabel/InputLabel.js + 1 modules
var InputLabel = __webpack_require__(47312);
// EXTERNAL MODULE: ./node_modules/@mui/material/InputAdornment/InputAdornment.js + 1 modules
var InputAdornment = __webpack_require__(87109);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 3 modules
var Button = __webpack_require__(69417);
// EXTERNAL MODULE: ./node_modules/@mui/material/Divider/Divider.js
var Divider = __webpack_require__(67720);
// EXTERNAL MODULE: ./node_modules/@mui/material/FormLabel/FormLabel.js
var FormLabel = __webpack_require__(40476);
// EXTERNAL MODULE: ./node_modules/@mui/material/RadioGroup/RadioGroup.js
var RadioGroup = __webpack_require__(68061);
// EXTERNAL MODULE: ./node_modules/@mui/material/FormControlLabel/FormControlLabel.js + 1 modules
var FormControlLabel = __webpack_require__(50480);
// EXTERNAL MODULE: ./node_modules/@mui/material/Radio/Radio.js + 5 modules
var Radio = __webpack_require__(36872);
// EXTERNAL MODULE: ./node_modules/@mui/material/Checkbox/Checkbox.js + 4 modules
var Checkbox = __webpack_require__(69368);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Add.js
var Add = __webpack_require__(96540);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-gtm-module/dist/index.js
var dist = __webpack_require__(1785);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
// EXTERNAL MODULE: ./components/FlightSearch/FlightSearch.module.scss
var FlightSearch_module = __webpack_require__(86277);
var FlightSearch_module_default = /*#__PURE__*/__webpack_require__.n(FlightSearch_module);
// EXTERNAL MODULE: ./components/FlightSearch/FlightSearchAutocomplete/FlightSearchAutocomplete.jsx
var FlightSearchAutocomplete = __webpack_require__(57907);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/FlightTakeoff.js
var FlightTakeoff = __webpack_require__(92585);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/FlightLand.js
var FlightLand = __webpack_require__(69649);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 112 modules
var formik_esm = __webpack_require__(28482);
// EXTERNAL MODULE: ./components/DatePicker/BCCDatePicker.jsx
var BCCDatePicker = __webpack_require__(28631);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Delete.js
var Delete = __webpack_require__(41733);
// EXTERNAL MODULE: ./components/PersonInput/PersonInput.jsx
var PersonInput = __webpack_require__(81001);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var yup_es = __webpack_require__(74231);
// EXTERNAL MODULE: ./utils/httpClient.js
var httpClient = __webpack_require__(22550);
// EXTERNAL MODULE: ./utils/cabinClasses.js
var cabinClasses = __webpack_require__(11723);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./node_modules/qs/lib/index.js
var lib = __webpack_require__(80129);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
;// CONCATENATED MODULE: ./utils/isWebView.js
var isWebView = function() {
    if (typeof document !== "undefined") {
        var standalone = window.navigator.standalone, userAgent = window.navigator.userAgent.toLowerCase(), safari = /safari/.test(userAgent), ios = /iphone|ipod|ipad/.test(userAgent);
        if (ios) {
            return !standalone && !safari;
        } else {
            return false;
        }
    } else {
        return false;
    }
};

// EXTERNAL MODULE: ./components/FlightSearch/TripTypeSelect/TripTypeSelect.module.scss
var TripTypeSelect_module = __webpack_require__(68158);
var TripTypeSelect_module_default = /*#__PURE__*/__webpack_require__.n(TripTypeSelect_module);
;// CONCATENATED MODULE: ./components/FlightSearch/TripTypeSelect/TripTypeSelect.jsx




var TripTypeSelect = function(param) {
    var tripState = param.tripState, handleTripTypeChange = param.handleTripTypeChange, values = param.values, handleChange = param.handleChange, viewMode = param.viewMode;
    var _obj, _obj1, _obj2;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (TripTypeSelect_module_default()).tripTypeSelectContainer,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()((TripTypeSelect_module_default()).tripStateItem, (_obj = {}, (0,_define_property/* default */.Z)(_obj, (TripTypeSelect_module_default()).active, tripState === "round_trip"), (0,_define_property/* default */.Z)(_obj, (TripTypeSelect_module_default()).smallerFont, viewMode === "sideSearch"), _obj)),
                onClick: function() {
                    return handleTripTypeChange("round_trip", handleChange, values);
                },
                children: "Round trip"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()((TripTypeSelect_module_default()).tripStateItem, (_obj1 = {}, (0,_define_property/* default */.Z)(_obj1, (TripTypeSelect_module_default()).active, tripState === "one_way"), (0,_define_property/* default */.Z)(_obj1, (TripTypeSelect_module_default()).smallerFont, viewMode === "sideSearch"), _obj1)),
                onClick: function() {
                    return handleTripTypeChange("one_way", handleChange, values);
                },
                children: "One way"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()((TripTypeSelect_module_default()).tripStateItem, (_obj2 = {}, (0,_define_property/* default */.Z)(_obj2, (TripTypeSelect_module_default()).active, tripState === "multi_city"), (0,_define_property/* default */.Z)(_obj2, (TripTypeSelect_module_default()).smallerFont, viewMode === "sideSearch"), _obj2)),
                onClick: function() {
                    return handleTripTypeChange("multi_city", handleChange, values);
                },
                children: "Multi-city"
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@mui/icons-material/SyncAlt.js
var SyncAlt = __webpack_require__(54336);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/ExpandMore.js
var ExpandMore = __webpack_require__(23508);
// EXTERNAL MODULE: ./utils/userSearchStorage.js
var userSearchStorage = __webpack_require__(85564);
;// CONCATENATED MODULE: ./components/FlightSearch/FlightSearch.jsx































var theme = (0,createTheme/* default */.Z)({
    shape: {
        borderRadius: 12
    },
    palette: {
        primary: {
            main: "#3C6562"
        },
        secondary: {
            main: "#202020"
        }
    },
    typography: {
        fontFamily: '"Libre Franklin", sans-serif'
    }
});
var FlightSearch = function(param) {
    var viewMode = param.viewMode, airlineName = param.airlineName, airlineCode = param.airlineCode, airlineClass = param.airlineClass, collapsed = param.collapsed, toggleSearch = param.toggleSearch, flightSearchValueProp = param.flightSearchValueProp, _widgetMode = param.widgetMode, widgetMode = _widgetMode === void 0 ? false : _widgetMode, _disablePortal = param.disablePortal, disablePortal = _disablePortal === void 0 ? true : _disablePortal, customHeader = param.customHeader, customSearchText = param.customSearchText, _openInNewTab = param.openInNewTab, openInNewTab = _openInNewTab === void 0 ? false : _openInNewTab, minDate = param.minDate, maxDate = param.maxDate, defaultSortBy = param.defaultSortBy, searchSource = param.searchSource, formRef = param.formRef;
    var setValidationSchema = function setValidationSchema(tripType) {
        if (tripType === "multi_city") {
            setSearchHotelState(false);
            setDisableHotelsSearch(true);
            setSearchSchema((0,yup_es/* object */.Ry)().shape({
                multi_city: (0,yup_es/* array */.IX)().of((0,yup_es/* object */.Ry)().shape({
                    from: fromValidator,
                    to: toValidator,
                    departure: (0,yup_es/* string */.Z_)().nullable().required("Please select departure date")
                }))
            }));
        } else if (tripType === "round_trip") {
            setDisableHotelsSearch(false);
            setSearchSchema((0,yup_es/* object */.Ry)().shape({
                from: fromValidator,
                to: toValidator,
                dateRange: (0,yup_es/* object */.Ry)().shape({
                    departure: (0,yup_es/* string */.Z_)().nullable().required("Please select departure date"),
                    return: (0,yup_es/* string */.Z_)().nullable().required("Please select return date")
                })
            }));
        } else {
            setDisableHotelsSearch(false);
            setSearchSchema((0,yup_es/* object */.Ry)().shape({
                from: fromValidator,
                to: toValidator,
                departure: (0,yup_es/* string */.Z_)().nullable().required("Please select departure date")
            }));
        }
    };
    var handleTripTypeChange = function handleTripTypeChange(value, handleChange, values) {
        patchFormValue(value, values);
        setValidationSchema(value);
        setTripState(value);
    };
    var patchFormValue = function patchFormValue(tripType, values) {
        if (values.passengers.length) {
            values.passengers.children = values.passengers[0].childrenAges;
            values.passengers.adults = values.passengers[0].adults;
        }
        switch(tripType){
            case "one_way":
                setFlightSearchValue((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, values), {
                    tripState: tripType,
                    passengers: {
                        adults: values.passengers.adults,
                        children: values.passengers.children
                    },
                    departure: values.departure ? values.departure : values.dateRange.departure
                }));
                break;
            case "round_trip":
                setFlightSearchValue((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, values), {
                    tripState: tripType,
                    passengers: {
                        adults: values.passengers.adults,
                        children: values.passengers.children
                    },
                    dateRange: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, values.dateRange), {
                        departure: values.dateRange.departure ? values.dateRange.departure : values.departure
                    })
                }));
                break;
            case "multi_city":
                var ref, ref1;
                setFlightSearchValue((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, values), {
                    tripState: tripType,
                    passengers: {
                        adults: values.passengers.adults,
                        children: values.passengers.children
                    },
                    multi_city: [
                        {
                            from: values.from,
                            to: values.to,
                            departure: values.multi_city && ((ref = values.multi_city[0]) === null || ref === void 0 ? void 0 : ref.departure) ? (ref1 = values.multi_city[0]) === null || ref1 === void 0 ? void 0 : ref1.departure : values.departure ? values.departure : values.dateRange.departure,
                            airlineType: "all"
                        }, 
                    ]
                }));
                break;
        }
    };
    var handleSwapDirections = function handleSwapDirections(values, setFieldValue, index) {
        if (index !== undefined) {
            var from = values.multi_city[index].from;
            var to = values.multi_city[index].to;
            values.multi_city[index].from = to;
            values.multi_city[index].to = from;
            setFlightSearchValue((0,_object_spread/* default */.Z)({}, values));
        } else {
            setFieldValue("from", values.to);
            setFieldValue("to", values.from);
        }
    };
    var ref = (0,react.useState)("round_trip"), tripState = ref[0], setTripState = ref[1];
    var ref1 = (0,react.useState)(collapsed), collapsedState = ref1[0], setCollapsedState = ref1[1];
    var ref2 = (0,react.useState)(false), searchHotelState = ref2[0], setSearchHotelState = ref2[1];
    var ref3 = (0,react.useState)(false), directOnlyState = ref3[0], setDirectOnlyState = ref3[1];
    var ref4 = (0,react.useState)(false), disableHotelsSearch = ref4[0], setDisableHotelsSearch = ref4[1];
    var ref5 = (0,react.useState)(flightSearchValueProp), flightSearchValue = ref5[0], setFlightSearchValue = ref5[1];
    var ref6 = (0,react.useState)(viewMode), activeViewMode = ref6[0], setActiveViewMode = ref6[1];
    var ref7 = (0,react.useState)(false), isSideSearch = ref7[0], setIsSideSearch = ref7[1];
    var ref8 = (0,react.useState)(false), isSideSearchMinimized = ref8[0], setIsSideSearchMinimized = ref8[1];
    var ref9 = (0,react.useState)(false), isMainSearch = ref9[0], setIsMainSearch = ref9[1];
    var ref10 = (0,react.useState)(false), openCabinClass = ref10[0], setOpenCabinClass = ref10[1];
    var userStore = (0,es/* useSelector */.v9)(function(state) {
        return state.user.value;
    });
    var router = (0,next_router.useRouter)();
    var DEFAULT_PASSENGERS = {
        adults: 1,
        children: []
    };
    var fromValidator = (0,yup_es/* object */.Ry)().nullable().required("Please select departure airport").test("from", "Departure should be different from arrival", function(item) {
        var ref;
        return ((ref = this.parent.to) === null || ref === void 0 ? void 0 : ref.Iata) !== (item === null || item === void 0 ? void 0 : item.Iata);
    });
    var toValidator = (0,yup_es/* object */.Ry)().nullable().required("Please select arrival airport").test("to", "Arrival should be different from departure", function(item) {
        var ref;
        return ((ref = this.parent.from) === null || ref === void 0 ? void 0 : ref.Iata) !== (item === null || item === void 0 ? void 0 : item.Iata);
    });
    var ref11 = (0,react.useState)((0,yup_es/* object */.Ry)().shape({
        from: fromValidator,
        to: toValidator,
        dateRange: (0,yup_es/* object */.Ry)().shape({
            departure: (0,yup_es/* string */.Z_)().nullable().required("Please select departure date"),
            return: (0,yup_es/* string */.Z_)().nullable().required("Please select return date")
        })
    })), searchSchema = ref11[0], setSearchSchema = ref11[1];
    var validateHotelSearchState = function(val) {
        if (moment_default()(val.return, "YYYY-MM-DD").diff(moment_default()(val.departure, "YYYY-MM-DD"), "days") > 30 || moment_default()(val.return, "YYYY-MM-DD").diff(moment_default()(val.departure, "YYYY-MM-DD"), "days") === 0) {
            setSearchHotelState(false);
            setDisableHotelsSearch(true);
        } else {
            setDisableHotelsSearch(false);
        }
    };
    (0,react.useEffect)(function() {
        if (flightSearchValue) {
            validateHotelSearchState(flightSearchValue.dateRange);
            setValidationSchema(flightSearchValue.tripState);
            setTripState(flightSearchValue.tripState);
        }
    }, [
        flightSearchValue
    ]);
    (0,react.useEffect)(function() {
        if (flightSearchValueProp) {
            setFlightSearchValue(flightSearchValueProp);
        }
    }, [
        flightSearchValueProp
    ]);
    (0,react.useEffect)(function() {
        if (router.query["stops"] && router.query["stops"] === "0") {
            setDirectOnlyState(true);
        }
    }, [
        router
    ]);
    (0,react.useEffect)(function() {
        setIsSideSearch(viewMode === "sideSearch");
        setIsSideSearchMinimized(viewMode === "sideSearchMinimized");
        setIsMainSearch(viewMode === "mainSearch");
        setActiveViewMode(viewMode);
    }, [
        viewMode
    ]);
    var toggleCollapsedSearch = function(event) {
        event.preventDefault();
        toggleSearch();
    };
    var executeSearch = function(values) {
        var ref, ref1, ref2, ref3;
        var query = {};
        query.cabinClass = values.cabinClass;
        query.adults = Array.isArray(Array.isArray(values.passengers) ? values.passengers[0] : values.passengers) ? (Array.isArray(values.passengers) ? values.passengers[0] : values.passengers)[0].adults : (Array.isArray(values.passengers) ? values.passengers[0] : values.passengers).adults;
        if ((ref = (Array.isArray(values.passengers) ? values.passengers[0] : values.passengers).children) === null || ref === void 0 ? void 0 : ref.length) {
            query.children = query.children = values.passengers.children;
        }
        query.qatarOnly = 0;
        var analyticsJourneys = [];
        var historyData = {
            cabinClass: values.cabinClass,
            adults: query.adults,
            children: query.children,
            tripState: tripState
        };
        historyData.cabinClass = values.cabinClass;
        historyData.adults = query.adults;
        historyData.children = query.children;
        switch(tripState){
            case "round_trip":
                var ref4, ref5;
                analyticsJourneys = [
                    {
                        originCountry: values.from.CountryCode,
                        originCity: values.from.city,
                        destinationCountry: values.to.CountryCode,
                        destinationCity: values.to.city
                    },
                    {
                        originCountry: values.to.CountryCode,
                        originCity: values.to.city,
                        destinationCountry: values.from.CountryCode,
                        destinationCity: values.from.city
                    }, 
                ];
                query.segments = [
                    {
                        origin: values.from.Iata,
                        destination: values.to.Iata,
                        departure: values.dateRange.departure,
                        exactAirport: !((ref4 = values.from) === null || ref4 === void 0 ? void 0 : ref4.Name.includes("All airports"))
                    },
                    {
                        origin: values.to.Iata,
                        destination: values.from.Iata,
                        departure: values.dateRange.return,
                        exactAirport: !values.to.Name.includes("All airports")
                    }, 
                ];
                historyData.segments = [
                    {
                        origin: values.from.Iata,
                        originName: values.from.city,
                        originCountry: values.from.CountryCode,
                        destination: values.to.Iata,
                        destinationName: values.to.city,
                        destinationCountry: values.to.CountryCode,
                        departure: values.dateRange.departure,
                        exactAirport: !((ref5 = values.from) === null || ref5 === void 0 ? void 0 : ref5.Name.includes("All airports"))
                    },
                    {
                        origin: values.to.Iata,
                        originName: values.to.city,
                        originCountry: values.to.CountryCode,
                        destination: values.from.Iata,
                        destinationName: values.from.city,
                        destinationCountry: values.from.CountryCode,
                        departure: values.dateRange.return,
                        exactAirport: !values.to.Name.includes("All airports")
                    }, 
                ];
                break;
            case "one_way":
                var ref6, ref7;
                analyticsJourneys = [
                    {
                        originCountry: values.from.CountryCode,
                        originCity: values.from.city,
                        destinationCountry: values.to.CountryCode,
                        destinationCity: values.to.city
                    }, 
                ];
                query.segments = [
                    {
                        origin: values.from.Iata,
                        destination: values.to.Iata,
                        departure: values.departure,
                        exactFrom: !((ref6 = values.from) === null || ref6 === void 0 ? void 0 : ref6.Name.includes("All airports")),
                        exactTo: !values.to.Name.includes("All airports")
                    }, 
                ];
                historyData.segments = [
                    {
                        origin: values.from.Iata,
                        originName: values.from.city,
                        originCountry: values.from.CountryCode,
                        destination: values.to.Iata,
                        destinationName: values.to.city,
                        destinationCountry: values.to.CountryCode,
                        departure: values.departure,
                        exactFrom: !((ref7 = values.from) === null || ref7 === void 0 ? void 0 : ref7.Name.includes("All airports")),
                        exactTo: !values.to.Name.includes("All airports")
                    }, 
                ];
                break;
            case "multi_city":
                var ref8, ref9, ref10;
                analyticsJourneys = (ref8 = values.multi_city) === null || ref8 === void 0 ? void 0 : ref8.map(function(destination) {
                    return {
                        originCountry: destination.from.CountryCode,
                        originCity: destination.from.city,
                        destinationCountry: destination.to.CountryCode,
                        destinationCity: destination.to.city
                    };
                });
                query.segments = (ref9 = values.multi_city) === null || ref9 === void 0 ? void 0 : ref9.map(function(destination) {
                    var ref;
                    return {
                        origin: destination.from.Iata,
                        destination: destination.to.Iata,
                        departure: destination.departure,
                        exactFrom: !((ref = destination.from) === null || ref === void 0 ? void 0 : ref.Name.includes("All airports")),
                        exactTo: !destination.to.Name.includes("All airports")
                    };
                });
                historyData.segments = (ref10 = values.multi_city) === null || ref10 === void 0 ? void 0 : ref10.map(function(destination) {
                    var ref;
                    return {
                        origin: destination.from.Iata,
                        originName: destination.from.city,
                        originCountry: destination.from.CountryCode,
                        destination: destination.to.Iata,
                        destinationName: destination.to.city,
                        destinationCountry: destination.to.CountryCode,
                        departure: destination.departure,
                        exactFrom: !((ref = destination.from) === null || ref === void 0 ? void 0 : ref.Name.includes("All airports")),
                        exactTo: !destination.to.Name.includes("All airports")
                    };
                });
                break;
        }
        if (values.airlineType !== "all") {
            query.airlines = airlineCode;
        }
        if (directOnlyState) {
            query.stops = 0;
        }
        if (defaultSortBy) {
            query.sortBy = defaultSortBy;
        }
        var tagManagerArgs = {
            dataLayer: {
                event: "flightSearch",
                flightType: tripState,
                journeys: analyticsJourneys,
                numGuests: ((ref1 = query.children) === null || ref1 === void 0 ? void 0 : ref1.length) > 0 ? +query.adults + ((ref2 = query.children) === null || ref2 === void 0 ? void 0 : ref2.length) : +query.adults,
                numAdults: +query.adults,
                numChildren: +((ref3 = query.children) === null || ref3 === void 0 ? void 0 : ref3.length),
                userCountry: userStore === null || userStore === void 0 ? void 0 : userStore.country.toUpperCase(),
                pageType: router === null || router === void 0 ? void 0 : router.pathname,
                loginStatus: userStore.userid ? "logged in" : "not logged in",
                membershipId: userStore === null || userStore === void 0 ? void 0 : userStore.membershipNumber,
                searchSource: searchSource,
                traffic_type: (userStore === null || userStore === void 0 ? void 0 : userStore.is_admin) ? "internal" : "external"
            }
        };
        dist_default().dataLayer(tagManagerArgs);
        (0,userSearchStorage/* saveFlightSearch */.o1)(historyData);
        if (widgetMode) {
            window.parent.postMessage(JSON.stringify({
                searchUrl: decodeURI("/flightsearch?".concat((lib_default()) === null || (lib_default()) === void 0 ? void 0 : lib_default().stringify(query || {})))
            }), "*");
        } else {
            query.tripState = tripState;
            if (searchHotelState) {
                var win = window.open();
                (0,httpClient/* httpGet */.kA)("/api/hotel/autocomplete?search=".concat(values.to.city)).then(function(response) {
                    response.json().then(function(result) {
                        var hotelQuery = {};
                        if (result.length) {
                            var ref;
                            if (tripState === "round_trip") {
                                hotelQuery.dateRange = values.dateRange;
                            } else if (tripState === "one_way") {
                                hotelQuery.dateRange = {
                                    departure: values.departure,
                                    return: moment_default()(values.departure).add(1, "day").format("yyyy-MM-DD")
                                };
                            } else {
                                var ref1, ref2;
                                hotelQuery.dateRange = {
                                    departure: (ref1 = values.multi_city[0]) === null || ref1 === void 0 ? void 0 : ref1.departure,
                                    return: moment_default()((ref2 = values.multi_city[0]) === null || ref2 === void 0 ? void 0 : ref2.departure).add(1, "day").format("yyyy-MM-DD")
                                };
                            }
                            hotelQuery.autocomplete = result.find(function(s) {
                                return s.s === 1 && (s.t === "cities" || s.t === "countries");
                            });
                            hotelQuery.visitors = [];
                            hotelQuery.visitors.push((0,_object_spread/* default */.Z)({
                                adults: values.passengers.adults || 1
                            }, ((ref = values.passengers.children) === null || ref === void 0 ? void 0 : ref.length) && {
                                childrenAges: values.passengers.children.map(function(c) {
                                    return +c;
                                })
                            }));
                            hotelQuery.search = 1;
                            if (query) {
                                win.location = decodeURI("/flightsearch?".concat(lib_default().stringify(query)));
                            } else {
                                console.error("User have no query");
                                win.location = decodeURI("/flightsearch");
                            }
                            if (hotelQuery) {
                                document.location = decodeURI("/hotelsearch?".concat(lib_default().stringify(hotelQuery)));
                            } else {
                                console.error("User have no hotelQuery");
                                document.location = decodeURI("/hotelsearch");
                            }
                        }
                    });
                });
            } else {
                window.open(decodeURI("/flightsearch?".concat((lib_default()) === null || (lib_default()) === void 0 ? void 0 : lib_default().stringify(query))), openInNewTab ? "_blank" : "_self");
                window.focus();
            }
        }
    };
    var handleHotelSearchChange = function(event) {
        setSearchHotelState(event.target.checked);
    };
    var handleDirectOnlyChange = function(event) {
        setDirectOnlyState(event.target.checked);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ThemeProvider/* default */.Z, {
        theme: theme,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "w-full overflow-auto",
            onClick: function() {
                return setCollapsedState(false);
            },
            children: [
                airlineClass && !collapsed && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "px-4 text-center lg:pt-7 pt-4 font-garamond",
                    children: [
                        !customHeader && isSideSearchMinimized && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                airlineName && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: (FlightSearch_module_default()).searchHeading,
                                            children: "Find the best offers for"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: (FlightSearch_module_default()).airlineCredentials,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: "mb-3",
                                                children: [
                                                    airlineName,
                                                    " ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "block mt-2",
                                                        children: "& more"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                !airlineName && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (FlightSearch_module_default()).searchHeading,
                                    children: "Search premium flight offers"
                                })
                            ]
                        }),
                        !customHeader && isSideSearch && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                airlineName && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: (FlightSearch_module_default()).searchHeading,
                                            children: "Find the best offers for"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: (FlightSearch_module_default()).airlineCredentials,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: "mb-3",
                                                children: [
                                                    airlineName,
                                                    " ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "block mt-2",
                                                        children: "& more"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                !airlineName && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (FlightSearch_module_default()).searchHeading,
                                    children: "Search premium flight offers"
                                })
                            ]
                        }),
                        !customHeader && isMainSearch && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: classnames_default()((FlightSearch_module_default()).airlineCredentials, "mb-4"),
                                children: airlineName ? "Find the best offers for ".concat(airlineName, " & more") : "Search premium flight offers"
                            })
                        }),
                        customHeader && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (FlightSearch_module_default()).airlineCredentials,
                            children: customHeader
                        })
                    ]
                }),
                collapsed && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "px-4 text-center pt-7 font-garamond relative",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (FlightSearch_module_default()).searchHeading,
                            children: "Search premium flight offers"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                            color: "inherit",
                            onClick: toggleCollapsedSearch,
                            "aria-label": "close",
                            className: "absolute top-0 right-0",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {})
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
                    innerRef: formRef || undefined,
                    enableReinitialize: true,
                    initialValues: flightSearchValue || {
                        from: "",
                        to: "",
                        trip: tripState,
                        dateRange: {
                            departure: null,
                            return: null
                        },
                        departure: null,
                        airlineType: "all",
                        passengers: {
                            adults: 1,
                            children: []
                        },
                        multi_city: [
                            {
                                from: "",
                                to: "",
                                departure: null,
                                airlineType: "all"
                            }, 
                        ],
                        cabinClass: "BIZ"
                    },
                    validationSchema: searchSchema,
                    onSubmit: function(values) {
                        executeSearch(values);
                    },
                    children: function(param) {
                        var setFieldValue = param.setFieldValue, handleChange = param.handleChange, values = param.values, errors = param.errors, touched = param.touched;
                        var _obj, _obj1, _obj2, _obj3, _obj4, _obj5;
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(formik_esm/* Form */.l0, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: classnames_default()((FlightSearch_module_default()).searchContainer, (_obj = {}, (0,_define_property/* default */.Z)(_obj, (FlightSearch_module_default()).sideSearch, isSideSearch), (0,_define_property/* default */.Z)(_obj, (FlightSearch_module_default()).sideSearchMinimized, isSideSearchMinimized), (0,_define_property/* default */.Z)(_obj, (FlightSearch_module_default()).mainSearch, isMainSearch), _obj)),
                                children: [
                                    !collapsedState && isSideSearchMinimized && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (FlightSearch_module_default()).tripTypeContainer,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Select/* default */.Z, {
                                            fullWidth: true,
                                            defaultValue: "round_trip",
                                            onChange: function(e) {
                                                return handleTripTypeChange(e.target.value, handleChange, values);
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                                                    value: "round_trip",
                                                    children: "Round trip"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                                                    value: "one_way",
                                                    children: "One way"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                                                    value: "multi_city",
                                                    children: "Multi city"
                                                })
                                            ]
                                        })
                                    }),
                                    !collapsedState && isSideSearch && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: classnames_default()((FlightSearch_module_default()).tripTypeContainer, {
                                            "flex-col": isSideSearch || isSideSearchMinimized,
                                            "flex items-center": isMainSearch
                                        }),
                                        children: !isSideSearchMinimized && /*#__PURE__*/ (0,jsx_runtime.jsx)(TripTypeSelect, {
                                            handleTripTypeChange: handleTripTypeChange,
                                            tripState: tripState,
                                            values: values,
                                            handleChange: handleChange,
                                            viewMode: activeViewMode
                                        })
                                    }),
                                    !collapsedState && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: classnames_default()((FlightSearch_module_default()).searchType, {
                                            "flex-col": isSideSearch || isSideSearchMinimized,
                                            "flex mb-4": isMainSearch
                                        }),
                                        children: [
                                            isMainSearch && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: classnames_default()((FlightSearch_module_default()).tripTypeContainer, "flex items-center"),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TripTypeSelect, {
                                                    handleTripTypeChange: handleTripTypeChange,
                                                    tripState: tripState,
                                                    values: values,
                                                    handleChange: handleChange,
                                                    viewMode: activeViewMode
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: classnames_default()((FlightSearch_module_default()).personAndClassColumn),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PersonInput/* PersonInput */.G, {
                                                        value: flightSearchValue ? flightSearchValue.passengers : DEFAULT_PASSENGERS,
                                                        name: "passengers",
                                                        setFieldValue: setFieldValue,
                                                        disablePortal: disablePortal
                                                    }),
                                                    !isSideSearchMinimized && /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormControl/* default */.Z, {
                                                        fullWidth: true,
                                                        className: classnames_default()(isSideSearchMinimized ? "my-4" : "ml-2"),
                                                        sx: {
                                                            paddingRight: "3px"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(InputLabel/* default */.Z, {
                                                                id: "cabin-label",
                                                                children: "Cabin class"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Select/* default */.Z, {
                                                                name: "cabinClass",
                                                                open: openCabinClass,
                                                                label: "Cabin class",
                                                                labelId: "cabin-label",
                                                                id: "cabinClass",
                                                                onClose: function() {
                                                                    return setOpenCabinClass(false);
                                                                },
                                                                onOpen: function() {
                                                                    return setOpenCabinClass(true);
                                                                },
                                                                value: values.cabinClass || (flightSearchValue === null || flightSearchValue === void 0 ? void 0 : flightSearchValue.cabinClass),
                                                                onChange: function(p) {
                                                                    handleChange(p);
                                                                    setOpenCabinClass(false);
                                                                },
                                                                IconComponent: function() {
                                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment/* default */.Z, {
                                                                        position: "end",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandMore/* default */.Z, {
                                                                            onClick: function() {
                                                                                return setOpenCabinClass(!openCabinClass);
                                                                            },
                                                                            sx: {
                                                                                cursor: "pointer"
                                                                            }
                                                                        })
                                                                    });
                                                                },
                                                                sx: {
                                                                    ".MuiSelect-select.MuiSelect-outlined.MuiOutlinedInput-input": {
                                                                        paddingRight: "3px"
                                                                    }
                                                                },
                                                                children: cabinClasses/* CABIN_CLASSES.map */.r.map(function(cabin) {
                                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                                                                        value: cabin.value,
                                                                        children: cabin.label
                                                                    }, cabin.value);
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    tripState !== "multi_city" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: classnames_default()((_obj1 = {}, (0,_define_property/* default */.Z)(_obj1, (FlightSearch_module_default()).sideInputContainer, isSideSearch || isSideSearchMinimized), (0,_define_property/* default */.Z)(_obj1, "mt-4", isSideSearch), (0,_define_property/* default */.Z)(_obj1, (FlightSearch_module_default()).mainAutocompleteInputContainer, isMainSearch), _obj1)),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FlightSearchAutocomplete/* FlightSearchAutocomplete */.s, {
                                                        setFieldValue: setFieldValue,
                                                        name: "from",
                                                        label: "From",
                                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(FlightTakeoff/* default */.Z, {}),
                                                        error: !!(touched.from && errors.from),
                                                        patch: {
                                                            value: values.from,
                                                            exact: values.exactFrom
                                                        }
                                                    }),
                                                    touched.from && errors.from && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (FlightSearch_module_default()).errorMessage,
                                                        children: errors.from
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (FlightSearch_module_default()).swapDirections,
                                                onClick: function() {
                                                    return handleSwapDirections(values, setFieldValue);
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SyncAlt/* default */.Z, {})
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: classnames_default()((_obj2 = {}, (0,_define_property/* default */.Z)(_obj2, (FlightSearch_module_default()).sideInputContainer, isSideSearch || isSideSearchMinimized), (0,_define_property/* default */.Z)(_obj2, (FlightSearch_module_default()).mainAutocompleteInputContainer, isMainSearch), _obj2)),
                                                style: {
                                                    marginTop: isSideSearch || isSideSearchMinimized ? "-1rem" : "unset"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FlightSearchAutocomplete/* FlightSearchAutocomplete */.s, {
                                                        setFieldValue: setFieldValue,
                                                        name: "to",
                                                        label: "To",
                                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(FlightLand/* default */.Z, {}),
                                                        error: !!(touched.to && errors.to),
                                                        patch: {
                                                            value: values.to,
                                                            exact: values.exactTo
                                                        }
                                                    }),
                                                    touched.to && errors.to && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (FlightSearch_module_default()).errorMessage,
                                                        children: errors.to
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    tripState === "round_trip" && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: !collapsedState && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: classnames_default()((_obj3 = {}, (0,_define_property/* default */.Z)(_obj3, (FlightSearch_module_default()).inputRangeContainer, isSideSearch || isSideSearchMinimized), (0,_define_property/* default */.Z)(_obj3, (FlightSearch_module_default()).mainInputRangeContainer, isMainSearch), (0,_define_property/* default */.Z)(_obj3, "flex", isMainSearch), (0,_define_property/* default */.Z)(_obj3, "flex-col", isSideSearch), _obj3), "p-0 justify-center"),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BCCDatePicker/* BCCDatePicker */.l, {
                                                    mode: "range",
                                                    labelStart: "Departure",
                                                    labelEnd: "Return",
                                                    setFieldValue: function(name, val) {
                                                        setFieldValue("dateRange", val);
                                                        validateHotelSearchState(val);
                                                    },
                                                    name: "dateRange",
                                                    viewMode: isSideSearchMinimized ? "vertical" : "horizontal",
                                                    rangeValue: [
                                                        values.dateRange.departure,
                                                        values.dateRange.return, 
                                                    ],
                                                    minDate: minDate || undefined,
                                                    maxDate: maxDate || undefined,
                                                    error: !!(touched && touched.dateRange && errors.dateRange),
                                                    errorMessages: touched && touched.dateRange && errors && errors.dateRange
                                                })
                                            })
                                        })
                                    }),
                                    tripState === "one_way" && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: classnames_default()((_obj4 = {}, (0,_define_property/* default */.Z)(_obj4, (FlightSearch_module_default()).sideInputContainer, isSideSearch || isSideSearchMinimized), (0,_define_property/* default */.Z)(_obj4, "mt-4", isSideSearch), (0,_define_property/* default */.Z)(_obj4, (FlightSearch_module_default()).mainDepartureInputContainer, isMainSearch), _obj4)),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BCCDatePicker/* BCCDatePicker */.l, {
                                                    mode: "single",
                                                    labelStart: "Departure",
                                                    setFieldValue: setFieldValue,
                                                    name: "departure",
                                                    minDate: new Date(),
                                                    value: values.departure,
                                                    error: !!(touched.departure && errors.departure)
                                                }),
                                                touched.departure && errors.departure && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (FlightSearch_module_default()).errorMessage,
                                                    children: errors.departure
                                                })
                                            ]
                                        })
                                    }),
                                    tripState === "multi_city" && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (FlightSearch_module_default()).multiCityContainer,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* FieldArray */.F2, {
                                                name: "multi_city",
                                                children: function(arrayHelpers) {
                                                    var ref;
                                                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                        children: [
                                                            (ref = values.multi_city) === null || ref === void 0 ? void 0 : ref.map(function(city, index) {
                                                                var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29;
                                                                var _obj, _obj1, _obj2;
                                                                /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                                                    className: classnames_default()({
                                                                        "w-full mt-4": isSideSearch
                                                                    }),
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: classnames_default()({
                                                                                flex: isMainSearch,
                                                                                "flex-col items-center": isSideSearch || isSideSearchMinimized
                                                                            }),
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                    className: classnames_default()((_obj = {}, (0,_define_property/* default */.Z)(_obj, (FlightSearch_module_default()).sideInputContainer, isSideSearch || isSideSearchMinimized), (0,_define_property/* default */.Z)(_obj, (FlightSearch_module_default()).mainInputContainer, isMainSearch), _obj)),
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FlightSearchAutocomplete/* FlightSearchAutocomplete */.s, {
                                                                                            setFieldValue: setFieldValue,
                                                                                            name: "multi_city.".concat(index, ".from"),
                                                                                            label: "From",
                                                                                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(FlightTakeoff/* default */.Z, {}),
                                                                                            patch: {
                                                                                                value: values.multi_city[index].from,
                                                                                                exact: values.multi_city[index].exactFrom
                                                                                            },
                                                                                            error: !!((touched === null || touched === void 0 ? void 0 : (ref = touched.multi_city) === null || ref === void 0 ? void 0 : (ref1 = ref[index]) === null || ref1 === void 0 ? void 0 : ref1.from) && (errors === null || errors === void 0 ? void 0 : (ref2 = errors.multi_city) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[index]) === null || ref3 === void 0 ? void 0 : ref3.from))
                                                                                        }),
                                                                                        (touched === null || touched === void 0 ? void 0 : (ref4 = touched.multi_city) === null || ref4 === void 0 ? void 0 : (ref5 = ref4[index]) === null || ref5 === void 0 ? void 0 : ref5.from) && (errors === null || errors === void 0 ? void 0 : (ref6 = errors.multi_city) === null || ref6 === void 0 ? void 0 : (ref7 = ref6[index]) === null || ref7 === void 0 ? void 0 : ref7.from) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                            className: (FlightSearch_module_default()).errorMessage,
                                                                                            children: errors === null || errors === void 0 ? void 0 : (ref8 = errors.multi_city) === null || ref8 === void 0 ? void 0 : (ref9 = ref8[index]) === null || ref9 === void 0 ? void 0 : ref9.from
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                !collapsedState && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                    className: (FlightSearch_module_default()).swapDirections,
                                                                                    onClick: function() {
                                                                                        return handleSwapDirections(values, setFieldValue, index);
                                                                                    },
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SyncAlt/* default */.Z, {})
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                    className: classnames_default()((_obj1 = {}, (0,_define_property/* default */.Z)(_obj1, (FlightSearch_module_default()).sideInputContainer, isSideSearch || isSideSearchMinimized), (0,_define_property/* default */.Z)(_obj1, (FlightSearch_module_default()).mainInputContainer, isMainSearch), (0,_define_property/* default */.Z)(_obj1, "ml-4", isMainSearch), _obj1)),
                                                                                    style: {
                                                                                        marginTop: isSideSearch || isSideSearchMinimized ? "-1rem" : "unset"
                                                                                    },
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FlightSearchAutocomplete/* FlightSearchAutocomplete */.s, {
                                                                                            setFieldValue: setFieldValue,
                                                                                            name: "multi_city.".concat(index, ".to"),
                                                                                            label: "To",
                                                                                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(FlightLand/* default */.Z, {}),
                                                                                            patch: {
                                                                                                value: values.multi_city[index].to,
                                                                                                exact: values.multi_city[index].exactTo
                                                                                            },
                                                                                            error: !!((touched === null || touched === void 0 ? void 0 : (ref10 = touched.multi_city) === null || ref10 === void 0 ? void 0 : (ref11 = ref10[index]) === null || ref11 === void 0 ? void 0 : ref11.to) && (errors === null || errors === void 0 ? void 0 : (ref12 = errors.multi_city) === null || ref12 === void 0 ? void 0 : (ref13 = ref12[index]) === null || ref13 === void 0 ? void 0 : ref13.to))
                                                                                        }),
                                                                                        (touched === null || touched === void 0 ? void 0 : (ref14 = touched.multi_city) === null || ref14 === void 0 ? void 0 : (ref15 = ref14[index]) === null || ref15 === void 0 ? void 0 : ref15.to) && (errors === null || errors === void 0 ? void 0 : (ref16 = errors.multi_city) === null || ref16 === void 0 ? void 0 : (ref17 = ref16[index]) === null || ref17 === void 0 ? void 0 : ref17.to) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                            className: (FlightSearch_module_default()).errorMessage,
                                                                                            children: errors === null || errors === void 0 ? void 0 : (ref18 = errors.multi_city) === null || ref18 === void 0 ? void 0 : (ref19 = ref18[index]) === null || ref19 === void 0 ? void 0 : ref19.to
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                    className: classnames_default()((_obj2 = {}, (0,_define_property/* default */.Z)(_obj2, (FlightSearch_module_default()).sideInputContainer, isSideSearch || isSideSearchMinimized), (0,_define_property/* default */.Z)(_obj2, "mt-4", isSideSearch), (0,_define_property/* default */.Z)(_obj2, (FlightSearch_module_default()).mainInputContainer, isMainSearch), _obj2)),
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BCCDatePicker/* BCCDatePicker */.l, {
                                                                                            mode: "single",
                                                                                            labelStart: "Departure",
                                                                                            setFieldValue: setFieldValue,
                                                                                            name: "multi_city.".concat(index, ".departure"),
                                                                                            minDate: index >= 1 && values.multi_city[index - 1].departure ? new Date(values.multi_city[index - 1].departure) : undefined,
                                                                                            value: values.multi_city[index].departure,
                                                                                            error: !!((touched === null || touched === void 0 ? void 0 : (ref20 = touched.multi_city) === null || ref20 === void 0 ? void 0 : (ref21 = ref20[index]) === null || ref21 === void 0 ? void 0 : ref21.departure) && (errors === null || errors === void 0 ? void 0 : (ref22 = errors.multi_city) === null || ref22 === void 0 ? void 0 : (ref23 = ref22[index]) === null || ref23 === void 0 ? void 0 : ref23.departure))
                                                                                        }),
                                                                                        (touched === null || touched === void 0 ? void 0 : (ref24 = touched.multi_city) === null || ref24 === void 0 ? void 0 : (ref25 = ref24[index]) === null || ref25 === void 0 ? void 0 : ref25.departure) && (errors === null || errors === void 0 ? void 0 : (ref26 = errors.multi_city) === null || ref26 === void 0 ? void 0 : (ref27 = ref26[index]) === null || ref27 === void 0 ? void 0 : ref27.departure) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                            className: (FlightSearch_module_default()).errorMessage,
                                                                                            children: errors === null || errors === void 0 ? void 0 : (ref28 = errors.multi_city) === null || ref28 === void 0 ? void 0 : (ref29 = ref28[index]) === null || ref29 === void 0 ? void 0 : ref29.departure
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        }),
                                                                        !!index && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                                            variant: "outlined",
                                                                            endIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Delete/* default */.Z, {}),
                                                                            color: "secondary",
                                                                            className: "mt-2",
                                                                            sx: {
                                                                                textTransform: "unset"
                                                                            },
                                                                            type: "button",
                                                                            onClick: function() {
                                                                                return arrayHelpers.remove(index);
                                                                            },
                                                                            children: "Remove Flight"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                                                                            variant: "middle",
                                                                            sx: {
                                                                                marginTop: ".75rem",
                                                                                marginBottom: ".75rem"
                                                                            }
                                                                        })
                                                                    ]
                                                                }, index);
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                                variant: "contained",
                                                                endIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Add/* default */.Z, {}),
                                                                type: "button",
                                                                sx: {
                                                                    textTransform: "unset"
                                                                },
                                                                onClick: function() {
                                                                    return arrayHelpers.push({
                                                                        from: "",
                                                                        to: "",
                                                                        departure: "",
                                                                        airlineType: "all"
                                                                    });
                                                                },
                                                                children: "Add another flight"
                                                            })
                                                        ]
                                                    });
                                                }
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: classnames_default()((_obj5 = {}, (0,_define_property/* default */.Z)(_obj5, (FlightSearch_module_default()).mainSubmitContainer, isMainSearch), (0,_define_property/* default */.Z)(_obj5, (FlightSearch_module_default()).mainSubmitContainerSide, isSideSearch || isSideSearchMinimized), _obj5)),
                                        children: [
                                            !!airlineName && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: classnames_default()({
                                                    "flex-col my-2": isSideSearch || isSideSearchMinimized,
                                                    "flex ml-6": isMainSearch
                                                }),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormControl/* default */.Z, {
                                                    className: "w-full block",
                                                    component: "fieldset",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FormLabel/* default */.Z, {
                                                            component: "legend",
                                                            children: "Search for"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(RadioGroup/* default */.Z, {
                                                            row: true,
                                                            "aria-label": "airlineType",
                                                            name: "airlineType",
                                                            defaultValue: (flightSearchValue === null || flightSearchValue === void 0 ? void 0 : flightSearchValue.airlineType) || "all",
                                                            onChange: handleChange,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                                                                    value: "all",
                                                                    control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio/* default */.Z, {}),
                                                                    label: "All airlines"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                                                                    value: airlineName,
                                                                    control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio/* default */.Z, {}),
                                                                    label: "".concat(airlineName, " only")
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: classnames_default()((FlightSearch_module_default()).mainSubmitMulticityButtonContainer),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                                                    className: classnames_default()("h-full"),
                                                    sx: {
                                                        textTransform: "unset"
                                                    },
                                                    fullWidth: true,
                                                    color: "primary",
                                                    variant: "contained",
                                                    type: "submit",
                                                    children: [
                                                        customSearchText && customSearchText,
                                                        !customSearchText && "Search"
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                children: [
                                                    !widgetMode && /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                                                        className: "mt-2 lg:mt-0",
                                                        disabled: isWebView(),
                                                        control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                                            onChange: handleDirectOnlyChange,
                                                            checked: directOnlyState,
                                                            className: "p-0 pl-2"
                                                        }),
                                                        label: "Show direct flights only"
                                                    }),
                                                    !widgetMode && /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                                                        className: "mt-2 lg:mt-0",
                                                        disabled: isWebView() || disableHotelsSearch,
                                                        control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                                            onChange: handleHotelSearchChange,
                                                            checked: searchHotelState,
                                                            className: "p-0 pl-2"
                                                        }),
                                                        label: "Search hotels"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        });
                    }
                })
            ]
        })
    });
};
/* harmony default export */ var FlightSearch_FlightSearch = (FlightSearch);


/***/ }),

/***/ 86277:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sideSearch":"FlightSearch_sideSearch___rV_m","tripTypeContainer":"FlightSearch_tripTypeContainer__bdTpg","searchType":"FlightSearch_searchType__HQENH","swapDirections":"FlightSearch_swapDirections__AmobF","personAndClassColumn":"FlightSearch_personAndClassColumn__gYn_E","sideInputContainer":"FlightSearch_sideInputContainer__r4ON_","inputRangeContainer":"FlightSearch_inputRangeContainer__Nx_de","multiCityContainer":"FlightSearch_multiCityContainer__vLL18","mainSubmitContainerSide":"FlightSearch_mainSubmitContainerSide__rgl7r","sideSearchMinimized":"FlightSearch_sideSearchMinimized__p2cWf","mainSubmitMulticityButtonContainer":"FlightSearch_mainSubmitMulticityButtonContainer__h73Jn","mainSubmitContainer":"FlightSearch_mainSubmitContainer__cR116","mainSearch":"FlightSearch_mainSearch__3IYe4","mainSubmitButtonContainer":"FlightSearch_mainSubmitButtonContainer__4pI8P","mainInputContainerMultiCity":"FlightSearch_mainInputContainerMultiCity__gHain","mainInputContainer":"FlightSearch_mainInputContainer__cVk9f","mainAutocompleteInputContainer":"FlightSearch_mainAutocompleteInputContainer___b3ei","mainPersonsInputContainer":"FlightSearch_mainPersonsInputContainer__DP_I3","mainInputRangeContainer":"FlightSearch_mainInputRangeContainer__0sYcH","mainTripTypeInputContainer":"FlightSearch_mainTripTypeInputContainer__O3S7_","mainSubmitButton":"FlightSearch_mainSubmitButton__Qnrix","mainDepartureInputContainer":"FlightSearch_mainDepartureInputContainer__B2cxu","searchHeading":"FlightSearch_searchHeading__QdYzj","airlineCredentials":"FlightSearch_airlineCredentials__WrJjB","errorMessage":"FlightSearch_errorMessage__eoMAJ"};

/***/ }),

/***/ 68158:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tripTypeSelectContainer":"TripTypeSelect_tripTypeSelectContainer__wiMzp","tripStateItem":"TripTypeSelect_tripStateItem__DykH3","active":"TripTypeSelect_active__pVp9l","smallerFont":"TripTypeSelect_smallerFont__fE15o"};

/***/ })

}]);